module.exports = __webpack_public_path__ + "img/card_1_ref_2.ff1e1128.jpg";